import { dictionaryCamelCaseConverter } from 'src/utils/dictionaryCamelCaseConverter';

export const sanitizeCountries = (data) => dictionaryCamelCaseConverter(data);
